// Environment configuration
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || window.location.origin;

const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

const config = {
    BACKEND_URL,
    WEBSOCKET_URL,
    RAZORPAY_KEY_ID,
    API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
    NODE_ENV: process.env.REACT_APP_NODE_ENV,
};

export default config;
